/**
 * @generated SignedSource<<26931100d4807e57df0200d0cfe136c5>>
 * @relayHash 13d791f2134e4ca2864744c8f12486d6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID f00f894c3a483dee5fdcc99a8b59da90f64230ee8a4f4d9cb11b0cc5f9f308d0

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { ui_jiraCalendarQuery } from './ui_jiraCalendarQuery.graphql';

const node: PreloadableConcreteRequest<ui_jiraCalendarQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "f00f894c3a483dee5fdcc99a8b59da90f64230ee8a4f4d9cb11b0cc5f9f308d0",
    "metadata": {},
    "name": "ui_jiraCalendarQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
